import { supabase } from '../supabaseClient';
import { safeStorage } from './safeStorage';

const USER_CACHE_KEY = 'gweffit_user_cache';

export async function updateStreakForActivity(userId) {
  try {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayStr = today.toISOString().split('T')[0];

    const cachedUser = safeStorage.get(USER_CACHE_KEY);
    let lastStreakDate = null;
    let currentStreak = 0;

    if (cachedUser) {
      const parsed = JSON.parse(cachedUser);
      lastStreakDate = parsed.last_streak_date;
      currentStreak = parsed.streak || 0;
    }

    if (lastStreakDate === todayStr) {
      console.log('🔥 Already completed streak activity today');
      return { updated: false, streak: currentStreak };
    }

    let newStreak = 1;
    if (lastStreakDate) {
      const lastDate = new Date(lastStreakDate);
      lastDate.setHours(0, 0, 0, 0);
      const daysSince = Math.floor((today - lastDate) / (1000 * 60 * 60 * 24));

      if (daysSince === 1) newStreak = currentStreak + 1;
      else if (daysSince > 1) newStreak = 1;
      else newStreak = currentStreak;
    }

    await supabase
      .from('users')
      .update({
        streak: newStreak,
        last_streak_date: todayStr,
        updated_at: new Date().toISOString(),
      })
      .eq('id', userId);

    if (cachedUser) {
      const parsed = JSON.parse(cachedUser);
      parsed.streak = newStreak;
      parsed.last_streak_date = todayStr;
      parsed.updated_at = new Date().toISOString();
      safeStorage.set(USER_CACHE_KEY, JSON.stringify(parsed));
    }

    console.log('🔥 Streak updated:', { newStreak, lastStreakDate, todayStr });
    return { updated: true, streak: newStreak };
  } catch (error) {
    console.error('❌ Failed to update streak:', error);
    return { updated: false, streak: 0 };
  }
}
